import { PhylloGender } from '@round/api';

export const genderAgeChartColors: Record<PhylloGender, string> = {
    MALE: '#7A61DF',
    FEMALE: '#EF5DA8',
    OTHERS: '',
};

export const colors: [string, string] = [genderAgeChartColors.MALE, genderAgeChartColors.FEMALE];
